<div class="belka_gorna MassValuation" >
  <div class="d-flex"> 
    <h1 class="p-2 ml-auto mr-auto w-100 text-white">
      <span id="masowa_wycena" [translation]="TranslationEnum.TranslationForm">{{'masowa_wycena'|translate}}</span>
    </h1>
    
  </div>
</div>

<div class="wczytywanie"><div *ngIf="FormData.wczytywanie > 0 || FormData.wczytywanie_wyceny"
    class="d-flex justify-content-center align-items-center  ">
        <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="50" >
        </mat-progress-spinner>
    </div>
</div>

<div class="wczytywanie_all" *ngIf="FormData.wczytywanie_all">
    <div class="wczytywanie_all_in d-flex justify-content-center align-items-center  ">
        <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="50" >
        </mat-progress-spinner>
    </div>
</div>



<div *ngIf = "FormData.naglowek || FormData.naglowekW" class="all">
    <h2 class="">
      <span id="dane_ogolne" [translation]="TranslationEnum.TranslationForm">{{'dane_ogolne'|translate}}</span>
    </h2>
     <div class="kroki" id = "krok_header" *ngIf = "FormData.naglowekW"  >
                <div *ngIf = "tresci.DevMode" class = "nazwa_krok"> {{FormData.naglowekW.Step}} ({{FormData.naglowekW.Type}})</div>
                <div class = "controls">
                        <ng-container   *ngFor="let control of FormData.naglowekW.Controlls; let j = index;">
                            
                            <ng-container *ngIf = "tresci.DevMode || !control.Hidden">
                                <div class="kontrolka_pole kontrolka_pole_{{control.ControlType}}">
                                   <app-form-control  [disabled] = "FormData.wczytywanie_wyceny" [FormData] = "FormData" [control] = "control" [i] = "i" [DevMode] = "tresci.DevMode" [system] = "FormData.system" ></app-form-control>
                                </div>
                            
                            </ng-container>
                                
                        </ng-container>
                </div>
                
    </div>
    <ng-container  *ngIf = "FormData.naglowek">
            <div class="kroki" id = "krok_header"   >
                    <div *ngIf = "tresci.DevMode" class = "nazwa_krok"> {{FormData.naglowek.Step}} ({{FormData.naglowek.Type}})</div>
                    <div class = "controls">
                            <ng-container   *ngFor="let control of FormData.naglowek.Controlls; let j = index;">
                                
                                <ng-container *ngIf = "tresci.DevMode || !control.Hidden">
                                    <div class="kontrolka_pole kontrolka_pole_{{control.ControlType}}">
                                    <app-form-control  [disabled] = "FormData.wczytywanie_wyceny" [FormData] = "FormData" [control] = "control" [i] = "i" [DevMode] = "tresci.DevMode" [system] = "FormData.system" ></app-form-control>
                                    </div>
                                
                                </ng-container>
                                    
                            </ng-container>
                    </div>
                    
        </div>
        <div class="moduly">
        <div class="moduly_box" >
            <ng-container   *ngFor="let mod of FormData.moduly; let m = index;">
                <div class="modul modul_{{m == FormData.widoczny_modul}} blad_{{mod.poprawne}}" (click) = "FormData.ZmienModul(m, formService)">
                    <span id="modul" [translation]="TranslationEnum.TranslationForm">{{'modul'|translate}}</span> {{m+1}}
                </div>
            </ng-container>
                <div class="modul" (click) = "FormData.DodajModul(formService)">
                    <span id="dodaj_modul" [translation]="TranslationEnum.TranslationForm">{{'dodaj_modul'|translate}}</span>
                </div>
                <div  class="modul modul_{{-1 == FormData.widoczny_modul}}" (click) = "FormData.ZmienModul(-1, formService)">
                    <span id="kim" [translation]="TranslationEnum.TranslationForm">{{'kim'|translate}}</span>
                </div>
            </div>
        </div>
        <div class="moduly_nad" *ngIf = "-1 == FormData.widoczny_modul && FormData.kim != null">
            <div class="kroki" id = "krok_kim"   >
                    <div *ngIf = "tresci.DevMode" class = "nazwa_krok"> {{FormData.kim.Step}} ({{FormData.kim.Type}})</div>
                    <div class = "controls">
                            <ng-container   *ngFor="let control of FormData.kim.Controlls; let j = index;">
                                
                                <ng-container *ngIf = "tresci.DevMode || !control.Hidden">
                                    <div class="kontrolka_pole kontrolka_pole_{{control.ControlType}}">
                                        <app-form-control  [disabled] = "FormData.wczytywanie_wyceny" [FormData] = "FormData" [control] = "control" [i] = "i" [DevMode] = "tresci.DevMode" [system] = "FormData.system" ></app-form-control>
                                    </div>
                                
                                </ng-container>
                                    
                            </ng-container>
                    </div>
                    
            </div>
        </div>
        <div class="moduly_nad"  *ngFor="let mod of FormData.moduly; let m = index;">
            <div class="moduly_box2" *ngIf = "m == FormData.widoczny_modul">
                    <div class="modul_ng">
                        <div class="pozycje_box" *ngIf = "FormData.moduly[m].moduleNg != null" >
                            <h2><span id="modul_poz" [translation]="TranslationEnum.TranslationForm">{{'modul_poz'|translate}}</span></h2>
                            <div class="kroki" id = "krok_modul"   >
                                <div *ngIf = "tresci.DevMode" class = "nazwa_krok"> {{FormData.moduly[m].moduleNg.Step}} ({{FormData.moduly[m].moduleNg.Type}})</div>
                                <div class = "controls">
                                        <ng-container   *ngFor="let control of FormData.moduly[m].moduleNg.Controlls; let j = index;">
                                            
                                            <ng-container *ngIf = "tresci.DevMode || !control.Hidden">
                                                <div class="kontrolka_pole kontrolka_pole_{{control.ControlType}}">
                                                    <app-form-control [disabled] = "FormData.wczytywanie_wyceny" [FormData] = "FormData" [control] = "control" [i] = "p" [DevMode] = "tresci.DevMode" [system] = "FormData.system" ></app-form-control>
                                                </div>
                                            
                                            </ng-container>
                                                
                                        </ng-container>
                                </div>
                                
                            </div>    
                        </div>
                    </div>

    <div class="pozycje">
                        <div class="pozycje_box" *ngIf = "FormData.moduly[m].pozycje && FormData.moduly[m].pozycje.length > 0" >
                            <h2><span id="pozycje" [translation]="TranslationEnum.TranslationForm">{{'pozycje'|translate}}</span></h2>
                            <div class="example-list"
                            cdkDropList
        #todoList="cdkDropList"
        [cdkDropListData]="FormData.moduly[m].pozycje"
        [cdkDropListConnectedTo]="[doneList]"
        (cdkDropListDropped)="drop($event, m+1)">
    <ng-container   *ngFor="let poz of FormData.moduly[m].pozycje; let p = index;">
                                <div class="pozycja" cdkDrag [cdkDragDisabled]="FormData.wczytywanie > 0 || FormData.wczytywanie_wyceny">
                                    <div class="numer_poz" >{{(p+1)}}</div>
                                    <div class="strzalki" cdkDragHandle>
                                        <mat-icon> drag_handle</mat-icon>
                                    </div>
                                    <div class="dane_poz">
                                        <div class="kroki" id = "krok_pozycja"   >
                                            <div *ngIf = "tresci.DevMode" class = "nazwa_krok"> {{mod.Step}} ({{mod.Type}})</div>
                                            <div class = "controls">
                                                    <ng-container   *ngFor="let control of poz.Controlls; let j = index;">
                                                        
                                                        <ng-container *ngIf = "tresci.DevMode || !control.Hidden">
                                                            <div class="kontrolka_pole kontrolka_pole_{{control.ControlType}}">
                                                                <app-form-control [disabled] = "FormData.wczytywanie_wyceny" [FormData] = "FormData" [control] = "control" [i] = "p" [DevMode] = "tresci.DevMode" [system] = "FormData.system" ></app-form-control>
                                                            </div>
                                                        
                                                        </ng-container>
                                                            
                                                    </ng-container>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="wycena">
                                        <ng-container *ngIf = "poz.Valuation">
                                            <div class="ceny">
                                                <div class="cena_ng">
                                                    <span id="cena_podstawowa" [translation]="TranslationEnum.TranslationForm">{{'cena_podstawowa'|translate}}</span>
                                                </div>
                                                <div class="cena">
                                                    <ng-container *ngFor="let cena of poz.getBasicPrice(); let c = index;">
                                                        <div class="cena_poz" title = "{{poz.getNamePrice(c)}}" >
                                                            {{cena | PriceFormat}}  {{poz.getCurrency()}}
                                                        </div>
                                                    </ng-container>
                                                    
                                                </div>
                                            </div>
                                            <div class="ceny">
                                                <div class="cena_ng">
                                                    <span id="rabat" [translation]="TranslationEnum.TranslationForm">{{'rabat'|translate}}</span>
                                                </div>
                                                <div class="cena">
                                                    <ng-container  *ngFor="let d of poz.getDiscount(); let c = index;">
                                                        <div class="cena_poz"  title = "{{poz.getNamePrice(c)}}" >
                                                            {{d}}
                                                        </div>
                                                    </ng-container>
                                                    
                                                    
                                                </div>
                                            </div>
                                            <div class="ceny">
                                                <div class="cena_ng">
                                                    <span id="cena_finalnie" [translation]="TranslationEnum.TranslationForm">{{'cena_finalnie'|translate}}</span>
                                                </div>
                                                <div class="cena">
                                        
                                                        {{poz.getFinalPrice() | PriceFormat}}  {{poz.getCurrency()}}
                                                
                                                    
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="usun_poz"  *ngIf="FormData.wczytywanie == 0 && !FormData.wczytywanie_wyceny"  (click) = "FormData.UsunPoz(FormData.widoczny_modul, p)"><mat-icon>delete</mat-icon></div>
                                </div>
                                
                            </ng-container>
    </div>
                            
                            <div class="pozycja"  *ngIf = "FormData.getFinalPriceMod(m) != 0">
                                    <div class="numer_poz2"></div>
                                    <div class="dane_poz">
                                    
                                    </div>
                                    <div>
                                    
                                    </div>
                                    <div class="wycena">
                                        <div class="ceny">
                                            <div class="cena_ng">
                                                
                                            </div>
                                            <div class="cena">
                                            
                                            </div>
                                        </div>
                                        <div class="ceny">
                                            <div class="cena_ng">
                                                
                                            </div>
                                            <div class="cena">
                                            
                                            </div>
                                        </div>
                                        <div class="ceny">
                                            <div class="cena_ng">
                                                <span id="cena_finalnie_mod" [translation]="TranslationEnum.TranslationForm">{{'cena_finalnie_mod'|translate}}</span>
                                            </div>
                                            <div class="cena">
                                                {{FormData.getFinalPriceMod(m) | PriceFormat}} {{FormData.currency}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="usun_poz2" ></div>
                                </div>

                        </div>
                        <div class="buttons">
                            <div class="dodaj_pozycje"   (click) = "FormData.Add(formService, FormData.widoczny_modul)">
                                <button class="btn-sm button"><span id="dodaj_pozycje" [translation]="TranslationEnum.TranslationForm">{{'dodaj_pozycje'|translate}}</span></button>
                            </div>
                            <div class="przelicz_wycenę"   (click) = "FormData.PrzeliczWycene(formService)" *ngIf = "!FormData.wczytywanie_wyceny && FormData.CzyPoprawneWycena()">
                                <button class="btn-sm button"><span id="przelicz_wycene" [translation]="TranslationEnum.TranslationForm">{{'przelicz_wycene'|translate}}</span></button>
                            </div>
                        </div>
                            
                    </div>
                    <div class="KopiujZestaw" *ngIf="FormData.wczytywanie == 0 && !FormData.wczytywanie_wyceny" (click) = "FormData.KopiujZestaw(m)"><mat-icon>control_point_duplicate</mat-icon><span id="kopiuj_zestaw" [translation]="TranslationEnum.TranslationForm">{{'kopiuj_zestaw'|translate}}</span></div>
                    <div class="UsunZestaw" *ngIf="FormData.wczytywanie == 0 && !FormData.wczytywanie_wyceny" (click) = "FormData.UsunZestaw(m)"><mat-icon>delete</mat-icon><span id="usun_zestaw" [translation]="TranslationEnum.TranslationForm">{{'usun_zestaw'|translate}}</span></div>
            
                    <div class="modul_ft">
                        <div class="pozycje_box" *ngIf = "FormData.moduly[m].moduleFooter != null" >
                            <h2><span id="modul_stopka" [translation]="TranslationEnum.TranslationForm">{{'modul_stopka'|translate}}</span></h2>
                            <div class="kroki" id = "krok_modul"   >
                                <div *ngIf = "tresci.DevMode" class = "nazwa_krok"> {{FormData.moduly[m].moduleFooter.Step}} ({{FormData.moduly[m].moduleFooter.Type}})</div>
                                <div class = "controls">
                                        <ng-container   *ngFor="let control of FormData.moduly[m].moduleFooter.Controlls; let j = index;">
                                            
                                            <ng-container *ngIf = "tresci.DevMode || !control.Hidden">
                                                <div class="kontrolka_pole kontrolka_pole_{{control.ControlType}}">
                                                    <app-form-control [disabled] = "FormData.wczytywanie_wyceny" [FormData] = "FormData" [control] = "control" [i] = "p" [DevMode] = "tresci.DevMode" [system] = "FormData.system" ></app-form-control>
                                                </div>
                                            
                                            </ng-container>
                                                
                                        </ng-container>
                                </div>
                                
                            </div>    
                        </div>
                    </div>
            
            
                </div>

            


        </div>
        
    <div class="ceny cena_finalna" *ngIf = "FormData.getFinalPrice() != 0">
        <div class="cena_ng">
            <span id="cena_finalnie_razem" [translation]="TranslationEnum.TranslationForm">{{'cena_finalnie_razem'|translate}}</span>
        </div>
        <div class="cena">
            {{FormData.getFinalPrice() | PriceFormat}} {{FormData.currency}}
        </div>
    </div>

    <div class="Zamow" *ngIf="FormData.wczytywanie == 0 && !FormData.wczytywanie_wyceny && FormData.CzyPoprawneCalosc()" >
        <button class="btn-sm button" (click) = "FormData.save(formService)"><span id="save_valuation" [translation]="TranslationEnum.TranslationForm">{{'save_valuation'|translate}}</span></button>
    </div>
    </ng-container>
    
</div>


<div class="devmode" *ngIf = "tresci.DevMode">
  <div>
    <button mat-flat-button color="primary" class="mr-2"  (click) = "showTechnology()"
    id="wyniki_technologi">
    Wyniki Technologii</button>
    <button mat-flat-button color="primary" class="mr-2"  (click) = "showTechnologyValuation()"
    id="wyniki_technologi">
    Wyniki Wyceny</button>
  </div>
  
  
 
  
  <button mat-flat-button color="primary" class="mr-2"  (click) = "logTMP()"
    id="wyniki_technologi">
    LOG TMP</button>
  <div *ngIf = "tresci.ostatnieParametry != null && tresci.ostatnieParametry.length > 0">
    <button mat-flat-button color="primary" class="mr-2"  (click) = "otworzDev(tresci.ostatnieParametry)"
    id="wyniki_technologi">
    Ostatnie wysłane parametry</button>
  </div>
  <div *ngIf = "FormData.ostatniKrok != null">
    <button mat-flat-button color="primary" class="mr-2"  (click) = "otworzDev(FormData.ostatniKrok)"
    id="wyniki_technologi">
    Ostatni otrzymany krok</button>
  </div>
 
  <div> 
    
  </div>
  
  
  
</div>
